import React from 'react'

type Props = {
  className?: string
  fillColor?: string
  size?: number
}

// Plain clock face (Lucide clock) — marks a connection that is simply waiting
// or has gone quiet, with no alert of its own. ClockAlert is the sibling that
// adds the "!" for a state the merchant has to act on. Stroked, matching the
// ClockAlert/ClockArrowUp convention so it satisfies the shared outlined-icon
// test contract.
const Clock = ({ className, fillColor = 'currentColor', size = 16 }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    stroke={fillColor}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z" />
    <path d="M12 7v5l3 2" />
  </svg>
)

export default Clock
